import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { IconBrandLoom, IconBrowser, IconHeadphones } from "@tabler/icons-react"
import { type FC } from "react"
import styled from "styled-components"

import { type IntendedPageType } from "@forento/core/models/course"

import Button from "~/components/Button"
import {
	CustomIcon,
	DragIndicatorIcon,
	type Icon,
	InputIcon,
	QuizIcon,
	TextIcon,
	VideoIcon,
	VimeoIcon,
	YouTubeIcon,
} from "~/components/Icon"
import { fonts } from "~/utilities/styles"

const icons: Record<IntendedPageType, Icon> = {
	video: VideoIcon,
	youtube: YouTubeIcon,
	vimeo: VimeoIcon,
	audio: IconHeadphones,
	quiz: QuizIcon,
	input: InputIcon,
	text: TextIcon,
	loom: IconBrandLoom,
	iframe: IconBrowser,
	custom: CustomIcon,
}

type Props = {
	page: { id: number; title: string; intendedType: IntendedPageType }
	order: number
	maxPageOrder: number
	onClick: () => void
}
const Page: FC<Props> = ({ page, order, maxPageOrder, onClick }) => {
	const { setNodeRef, attributes, listeners, transform, transition } = useSortable({ id: page.id })

	return (
		<Container style={{ transform: CSS.Transform.toString(transform), transition }} ref={setNodeRef}>
			<Clickable onClick={onClick}>
				<Number>{(order + 1).toString().padStart(maxPageOrder.toString().length, "0")}</Number>
				<StyledTypeIcon as={icons[page.intendedType]} />
				<Title>{page.title}</Title>
			</Clickable>
			<DragIndicator {...attributes} {...listeners} />
		</Container>
	)
}

const Container = styled.div`
	width: 100%;
	border-bottom: 1px solid #e1e1e1;
	display: flex;
	justify-content: space-between;
	align-items: center;
`

const Clickable = styled(Button)`
	flex: 1;
	display: flex;
	align-items: center;
	padding: 4px 0;
`

const Number = styled.p`
	font-family: ${fonts.mono};
	font-weight: 600;
	font-size: 14px;
	margin-right: 16px;
`

const StyledTypeIcon = styled.div`
	width: 18px;
	height: 18px;
	margin-right: 6px;
`

const Title = styled.p`
	font-weight: 500;
	font-size: 16px;
	flex: 1;
`

const DragIndicator = styled(DragIndicatorIcon)`
	width: 24px;
	height: 24px;
	cursor: grab;
`

export default Page
